/**
 * РЕЖИМ ЗВУКА НА IPHONE
 *
 * Голосовое на iPhone играло беззвучно: полоска бежит, а звука нет.
 * На компьютере то же голосовое слышно.
 *
 * iPhone сам решает, куда и как выводить звук страницы, и решает
 * неудачно для мессенджера:
 *
 *  - стоит странице хоть раз включить звуковую обработку (у нас она
 *    рисует дорожку при записи голосового и играет гудок звонка), как
 *    весь её звук становится «фоновым» и глушится переключателем
 *    бесшумного режима — тем, что сбоку на корпусе;
 *  - после записи с микрофона звук остаётся в разговорном динамике,
 *    у уха, где его почти не слышно.
 *
 * Safari позволяет странице сказать прямо, чем она занята. «Проигрываю»
 * — звук идёт в основной динамик и не глушится бесшумным режимом, как
 * у музыки и голосовых в любом мессенджере: человек сам нажал «слушать».
 * «Записываю и говорю» — для записи и звонков. Остальные браузеры этого
 * не умеют и не нуждаются: у них звук и так идёт куда надо.
 */

type SessionType = 'auto' | 'playback' | 'play-and-record'

type AudioSession = { type: string }

const session = (): AudioSession | null =>
  (navigator as unknown as { audioSession?: AudioSession }).audioSession ?? null

function set(type: SessionType): void {
  const current = session()
  if (!current) return
  try {
    if (current.type !== type) current.type = type
  } catch {
    /* старый Safari: свойство есть, но менять его нельзя */
  }
}

/**
 * Сейчас будем слушать запись.
 *
 * Во время звонка или записи не вмешиваемся: переключение отняло бы
 * микрофон посреди разговора.
 */
export function forPlayback(): void {
  if (session()?.type === 'play-and-record') return
  set('playback')
}

/** Включаем микрофон: запись голосового, кружка или звонок. */
export function forRecording(): void {
  set('play-and-record')
}

/** Микрофон больше не нужен — отдаём решение телефону. */
export function releaseRecording(): void {
  if (session()?.type === 'play-and-record') set('auto')
}
